"use strict"

import { getLoggedIn } from '../utils/cookies';

export function init() {
    if (getLoggedIn()) {
        document.body.classList.add('user-logged-in');
    } else {
        document.body.classList.add('user-logged-out');
    }

    document.querySelectorAll('.js-append-returnurl').forEach(el => {
        const separator = el.dataset.href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${el.dataset.href}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}
